import axios from '../axios/axios';
import {
  HEALTH_LIFESTYLE_DATA_REQUEST,
  HEALTH_LIFESTYLE_DATA_SUCCESS,
  HEALTH_LIFESTYLE_DATA_FAIL,
} from '../constants/healthAndLifeStyleConstants';

export const healthLifeStyleAction = () => async (dispatch) => {
  try {
    dispatch({ type: HEALTH_LIFESTYLE_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s7',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: HEALTH_LIFESTYLE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: HEALTH_LIFESTYLE_DATA_FAIL,
      payload: error,
    });
  }
};
